import { combineReducers } from 'redux';

import magazineArticles from './magazineArticles/reducer';
import magazineContribute from './magazineContribute/reducer';
import textEditing from './textEditing/reducer';
import paging from './paging/reducer';
import emojis from './emojis/reducer';

export default combineReducers({
  magazineArticles,
  magazineContribute,
  textEditing,
  paging,
  emojis
});



/** WEBPACK FOOTER **
 ** ./src/members/state/magazine/reducer.js
 **/